<app-progress-spinner [show]="isLoading"></app-progress-spinner>

@if (!isLoading) {
  <div class="flyout-header">
    <h2 class="flyout-header-title">{{ 'Lab Requisition' | translate }} {{ labRequisitionDetails?.labRequisitionNumber || '-' }}</h2>
    <div class="flyout-header-actions">
      <button type="button" mat-flat-button color="primary" class="import-results-btn"
        (click)="openImportResults()">
        <span class="material-icons">file_upload</span>
        {{ 'Import Results' | translate }}
      </button>
      <button type="button" mat-stroked-button color="primary" class="view-coc-btn" [disabled]="isGeneratingCoc"
        (click)="viewCurrentCoc()">
        <span class="material-icons">picture_as_pdf</span>
        {{ 'View Current COC' | translate }}
      </button>
      @if (canDownloadResultTemplate) {
        <button type="button" mat-stroked-button color="primary" class="download-template-btn"
          (click)="downloadResultTemplate()">
          <span class="material-icons">file_download</span>
          {{ 'Download Lab Result Template' | translate }}
        </button>
      }
    </div>
  </div>
  <div class="lab-requisition-info-container">
    <div class="lab-requisition-details">
      @for (field of detailFields; track trackByIndex($index)) {
        <div class="form-row">
          <label [attr.for]="field.id">{{ field.label | translate }}:</label>
          <input [id]="field.id" type="text" [value]="field.value" disabled />
        </div>
      }
      <div class="form-row attachments-row">
        <label>{{ 'Attachments' | translate }}:</label>
        @if (labRequisitionDetails?.fileAttachments?.length) {
          <div class="attachments-list">
            @for (attachment of labRequisitionDetails.fileAttachments; track trackByIndex($index)) {
              <button type="button" (click)="openAttachment(attachment)" class="attachment-link clickable"
                [title]="'Download ' + attachment.name" [attr.aria-label]="'Download ' + attachment.name">
                <span class="material-icons">attachment</span>
                {{ attachment.name }}
              </button>
            }
          </div>
        } @else {
          <span class="no-attachments">-</span>
        }
      </div>
    </div>
  </div>
}

@if (!isLoading) {
  <div class="custom-theme-table lab-requisition-samples-table">
    <div class="custom-scrollbar table-responsive outer-bordered-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
            {{ 'No samples assigned to this COC' | translate }}
          </td>
        </tr>
        <ng-container matColumnDef="sampleId">
          <th mat-header-cell *matHeaderCellDef>{{ 'Sample ID' | translate }}</th>
          <td mat-cell *matCellDef="let element" [attr.rowspan]="element.isFirstRow ? element.rowspan : null"
            [style.display]="element.isFirstRow ? '' : 'none'" class="vertical-border">
            {{ element.sample?.sampleNumber || '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="agent">
          <th mat-header-cell *matHeaderCellDef>{{ 'Agent' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.agent?.agentName || '-' }}
          </td>
        </ng-container>
        @for (column of nestedColumns; track trackByIndex($index)) {
          <ng-container [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef>{{ column.label | translate }}</th>
            <td mat-cell *matCellDef="let element">
              {{ column.getValue(element.agent) }}
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
          <td mat-cell *matCellDef="let element" [attr.rowspan]="element.isFirstRow ? element.rowspan : null"
            [style.display]="element.isFirstRow ? '' : 'none'" class="vertical-border">
            <mat-form-field appearance="fill" class="status-select">
              <mat-select [value]="element.sample.sampleStatus" panelClass="status-dropdown-panel"
                (selectionChange)="onStatusChange(element.sample, $event.value)">
                <mat-select-trigger>
                  <span class="status-badge" [ngClass]="element.statusBadgeClass">
                    {{ element.statusLabel | translate }}
                  </span>
                </mat-select-trigger>
                @for (status of element.statusOptions; track status.id) {
                  <mat-option [value]="status.id"
                    class="status-dropdown-options">
                    <span class="status-badge" [ngClass]="status.badgeClass">
                      {{ status.name | translate }}
                    </span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
          <td mat-cell *matCellDef="let element" [attr.rowspan]="element.isFirstRow ? element.rowspan : null"
            [style.display]="element.isFirstRow ? '' : 'none'" class="vertical-border">
            @if (element.canUnlink) {
              <button mat-icon-button [title]="'Unlink sample from COC' | translate"
                [attr.aria-label]="'Unlink sample from COC' | translate" (click)="onUnlinkSample(element)"
                class="action-button">
                <span class="material-icons">link_off</span>
              </button>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even"></tr>
      </table>
    </div>
    <div class="paginator-container">
      <span>{{ 'Displaying' | translate }}</span>
      <mat-paginator [length]="totalSamples" [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="10"></mat-paginator>
    </div>
  </div>
}